import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { authApi } from '../api/auth';
import { useAuth } from '../context/AuthContext';
import { getProjectRedirectUrl } from '../utils/projectRedirect';

const RegisterPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const redirectUri = searchParams.get('redirect_uri') || `${window.location.origin}/`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await authApi.signup({ name, email, password, redirectUri });
      const { isSuccess, result, message } = response.data;
      if (!isSuccess || !result) {
        setError(message || '회원가입에 실패했습니다.');
        return;
      }
      localStorage.setItem('accessToken', result.accessToken);
      const me = await login();
      const destination = getProjectRedirectUrl(me, result.redirectUri);
      window.location.href = destination;
    } catch (err: any) {
      setError(err.response?.data?.message || '회원가입 처리 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-orbit auth-orbit-a" aria-hidden="true" />
      <div className="auth-orbit auth-orbit-b" aria-hidden="true" />
      <div className="auth-orbit auth-orbit-c" aria-hidden="true" />

      <div className="auth-shell auth-shell-login-only fade-in">
        <div className="auth-brand-corner" aria-hidden="true">
          <div className="auth-brand-wordmark">omongkr</div>
        </div>

        <section className="auth-panel card">
          <div className="auth-panel-head">
            <h2 className="auth-panel-title">회원가입</h2>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label className="label">이름</label>
              <div className="auth-input-row">
                <input
                  className="input auth-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder="홍길동"
                />
              </div>
            </div>

            <div className="auth-field">
              <label className="label">이메일</label>
              <div className="auth-input-row">
                <input
                  type="email"
                  className="input auth-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="name@company.com"
                />
              </div>
            </div>

            <div className="auth-field">
              <label className="label">비밀번호</label>
              <div className="auth-input-row">
                <input
                  type="password"
                  className="input auth-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                />
              </div>
            </div>

            {error && <div className="auth-error-box">{error}</div>}

            <button className="btn btn-primary auth-submit-btn" type="submit" disabled={loading}>
              {loading ? '처리 중...' : <>가입하기 <ArrowRight size={18} /></>}
            </button>

            <div className="auth-inline-links">
              <span>이미 계정이 있나요?</span>
              <button
                type="button"
                onClick={() => navigate(`/login?redirect_uri=${encodeURIComponent(redirectUri)}`)}
                className="auth-link-btn"
              >
                로그인
              </button>
            </div>
          </form>
        </section>
      </div>
    </div>
  );
};

export default RegisterPage;
